import {Component} from '@angular/core';

import {
    AppAlertService,
    FormsService,
    ParametersService,
    SettingsAccountService,
    SubtitlesService
} from "../../core";

@Component({
    selector: 'settings-account',
    templateUrl: './settings-account.component.html',
    styleUrls: ['./settings-account.component.scss']
})
export class SettingsAccountComponent {
    constructor(
        public appAlert: AppAlertService,
        public forms: FormsService,
        private parameters: ParametersService,
        public settingsAccount: SettingsAccountService,
        public subtitles: SubtitlesService,
    ) {
    }

    openDialog(dialog: string): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }
        this.settingsAccount.openDialogForm(dialog);
    }

    closeDialog(): void {
        this.settingsAccount.closeDialogForm();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    generateApiToken(): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }

        this.settingsAccount.generateApiToken();
    }
}
